<template>
    <div>
        <div class="content">
          <div style="display: flex !important">
            <router-link class="d-inline-block custom-grid-25" :to="'agent-journey'">
                <div class="caption roadmap-nav-padding-ipad roadmap-agent-bg-ipad roadmap-nav-font">
                    <div class="position-top margin-bottom-5 custom-horizontal-12">
                        <div class="left-text grid-font-18 ">Training</div>
                        <div class="left-text grid-font-18 ">Support</div>
                        <div class="left-text grid-font-18 ">for Success</div>    
                    </div>
                </div>
            </router-link>
            <router-link class="d-inline-block custom-grid-25 middle-grid-margin-left" :to="'agent-journey-normal'">
                <div class="caption roadmap-nav-padding-ipad roadmap-agent-normal-bg-ipad roadmap-nav-font">
                    <div class="position-top margin-bottom-5 custom-horizontal-12">
                        <div class="left-text grid-font-18 ">Memory Lane</div>
                    </div>
                </div>
            </router-link>
          </div>
        </div>
    </div>
</template>
<style scoped>
.left-text{
    color: black;
}
.position-top{
    position: absolute;
    /* bottom: 10; */
    top: 50px;
}
.position-bottom{
    position: absolute;
    bottom: 0;
}
.custom-grid-25 {
    width: 20%;
}
.middle-grid-margin {
    margin-right: 10px;
}
.middle-grid-margin-left {
    margin-left: 10px;
}
.middle-grid-margin {
    margin-left: 10px;
    margin-right: 10px;
}
.grid-font-18 {
    font-size: 18px;
}
@media screen and (max-width:765px){
    .custom-grid-25 {
        width: 50%;
    }

    .roadmap-nav-padding-ipad{
        max-width: none;
    }
}
</style>
<script>
export default {
    name: 'RoadmapNav',
    data(){
        return {}
    },
    computed: {},
    components: {},
    methods: {}
}
</script>
